import { Tracking } from '../helpers/enums';
import { trackEvent } from '../tracking/helpers';

export const showIfCaps = () => {
  const capsInputs = document.querySelectorAll('[js-show-if-caps-input]');

  let invalidEventLogged = false;

  const logInvalidEventShape = () => {
    if (invalidEventLogged) {
      return;
    }

    invalidEventLogged = true;

    trackEvent({ eventName: Tracking.SHOW_IF_CAPS_INVALID, eventData: { event_source: 'showIfCaps' } });
  };

  if (capsInputs && !!capsInputs.length) {
    capsInputs.forEach((inputField) => {
      const capsId = inputField.getAttribute('js-show-if-caps-input');
      const field = document.querySelector(`[js-show-if-caps-field="${capsId}"]`);

      const handleKeyEvent = (evt: Event) => {
        const keyEvt = evt as KeyboardEvent;

        const canReadCapsLock = typeof keyEvt.getModifierState === 'function';

        if (!canReadCapsLock) {
          logInvalidEventShape();
        }

        const capsState = canReadCapsLock ? keyEvt.getModifierState('CapsLock') : false;

        field?.classList[capsState ? 'remove' : 'add']('display--n');
      };

      if (field) {
        inputField.addEventListener('keydown', handleKeyEvent);
        inputField.addEventListener('keyup', handleKeyEvent);

        field.classList.add('display--n');
      }
    });
  }
};
